// Wait until the document loads to to do anything.
document.addEventListener("DOMContentLoaded", () => {
  wireSidebar();
});

function wireSecurity() {
  console.log("wireSecurity", "isLoggedIn", isLoggedIn);
  document.body.classList.add(isLoggedIn() ? "logged-in" : "logged-out");

  const collection = document.getElementsByClassName("logout");

  for (let i = 0; i < collection.length; i++) {
    collection[i].addEventListener(
      "click",
      (event) => {
        localStorage.removeItem("security");
        window.location.reload();
        event.preventDefault();
      },
      false,
    );
  }
}

function wireSidebar() {
  // Wire up the sidebar elements and controls.
  const sidebar = document.getElementById("sidebar");
  const sidebarScreen = document.getElementById("sidebar-screen");
  const sidebarClose = document.getElementById("sidebar-close");
  const sidebarOpen = document.getElementById("sidebar-open");

  function showSidebar() {
    sidebar.classList.add("sidebar-hidden");
    sidebar.classList.remove("sidebar-shown");
    sidebarScreen.classList.add("sidebar-hidden");
    sidebarScreen.classList.remove("sidebar-shown");
  }

  sidebarScreen.addEventListener(
    "click",
    () => {
      showSidebar();
    },
    false,
  );

  sidebarClose.addEventListener(
    "click",
    () => {
      showSidebar();
    },
    false,
  );

  sidebarOpen.addEventListener(
    "click",
    () => {
      sidebar.classList.remove("sidebar-hidden");
      sidebar.classList.add("sidebar-shown");
      sidebarScreen.classList.remove("sidebar-hidden");
      sidebarScreen.classList.add("sidebar-shown");
    },
    false,
  );
}
